module.exports = __webpack_public_path__ + "static/appstoreimg-5d66af629dcc131ddb4a3b7e51f4755c.png";